// @Version: 1.0.0
import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ERROR } from 'build/project/openapi-cast/shared/shared-openapi-cast.model';
import { Observable } from 'rxjs';
import { NoMobileService } from 'src/app/shared/services/no-mobile/no-mobile.service';
import { ReloadService } from 'src/app/shared/services/reload/reload.service';
import { ResponsiveService } from 'src/app/shared/services/responsive/responsive.service';
import { BANKLOGO_POS, TRANSLATE_PATH } from 'src/app/shared/shared.model';
 
@Component({
   selector: 'app-blank-no-login',
   templateUrl: './blank-no-login.component.html',
   standalone: false
})
export class BlankNoLoginComponent {
   public TRANSLATE_PATH: typeof TRANSLATE_PATH = TRANSLATE_PATH;
   public BANKLOGO_POS = BANKLOGO_POS;
   public ERROR = ERROR;
   
   public location: Location;
   public reload$: Observable<string> = this.sReload.reloadPage$;

   @Output() public sidenavToggle = new EventEmitter();

   constructor (public sReload: ReloadService, public sResponsive: ResponsiveService, public sNoMobile: NoMobileService) {
      this.location = location;
      this.sNoMobile.noMobile = TRANSLATE_PATH.BLANK_NOMOBILE_ENABLED;
   }

   public onClickToggle(): void {
      this.sidenavToggle.emit();
   }
}
